import { Home, Activity, Wallet, FileText, User, LogOut } from 'lucide-react';

export default function InvestorLayout({ children, user, onLogout, currentPage }) {
  const navItems = [
    { name: 'Dashboard', icon: Home, path: '/investor', key: 'dashboard' },
    { name: 'Investments', icon: Activity, path: '/investor/investments', key: 'investments' },
    { name: 'Payouts', icon: Wallet, path: '/investor/payouts', key: 'payouts' },
    { name: 'Statement', icon: FileText, path: '/investor/statement', key: 'statement' },
    { name: 'Profile', icon: User, path: '/investor/profile', key: 'profile' },
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Top Navigation */}
      <nav className="bg-card border-b sticky top-0 z-50" data-testid="investor-navbar">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Factskoot
              </h1>
              <p className="text-sm text-muted-foreground">Investor Portal</p>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="hidden md:flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="text-sm font-semibold">{user?.full_name?.charAt(0) || 'I'}</span>
                </div>
                <div>
                  <p className="text-sm font-medium">{user?.full_name}</p>
                  <p className="text-xs text-muted-foreground">{user?.email}</p>
                </div>
              </div>
              <button
                data-testid="logout-button"
                onClick={onLogout}
                className="flex items-center space-x-2 px-4 py-2 rounded-md text-destructive hover:bg-destructive/10 transition-all"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
                <span className="hidden md:inline font-medium">Logout</span>
              </button>
            </div>
          </div>
          
          <div className="flex space-x-1 mt-4 overflow-x-auto">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPage === item.key;
              return (
                <a
                  key={item.key}
                  href={item.path}
                  data-testid={`nav-${item.key}`}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-md transition-all whitespace-nowrap ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-secondary'
                  }`}
                >
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                  <span className="text-sm font-medium">{item.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-6 md:p-8 lg:p-12">
        {children}
      </div>
    </div>
  );
}